import { BusinessForms } from '@query/businesses'

const BUSINESS_FORM_LABEL_MAP: Record<string, BusinessForms> = {
  'limited company': BusinessForms.FI_OY,
  'public limited company': BusinessForms.FI_OYJ,
  'private person carrying on trade': BusinessForms.FI_TMI,
  'limited partnership': BusinessForms.FI_KY,
  partnership: BusinessForms.FI_AY,
  'business partnership': BusinessForms.FI_AY,
  cooperative: BusinessForms.FI_OK,
  'housing corporation': BusinessForms.FI_AS_OY,
  'mutual real estate limited company': BusinessForms.FI_KOY,
  'other real estate limited company': BusinessForms.FI_KOY,
  'non-profit association': BusinessForms.FI_YHD,
  'association for carrying on economic activity': BusinessForms.FI_YHD,
  'other association': BusinessForms.FI_YHD,
  'association based on special legislation': BusinessForms.FI_YHD,
  'student union or student club': BusinessForms.FI_YHD,
  'chamber of commerce': BusinessForms.FI_YHD
}

const normalizeYtjBusinessFormLabel = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/[\u2019\u00b4]/g, "'")
    .replace(/\s+/g, ' ')

export const mapYTJBusinessForm = (ytjBusinessForm?: string | null): BusinessForms | undefined => {
  if (!ytjBusinessForm) return undefined

  const trimmed = ytjBusinessForm.trim()
  if (!trimmed) return undefined

  const normalized = normalizeYtjBusinessFormLabel(trimmed)
  return BUSINESS_FORM_LABEL_MAP[normalized]
}
